import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useApplication} from "../ApplicationProvider";
import {observer} from "mobx-react";
import {ModalDeliveryPointAndPurchaseOrderNumber} from "../functionalities/products/detail/ModalDeliveryPointAndPurchaseOrderNumber";
import {SelectDeliveryPointFeature} from "../functionalities/products/detail/SelectDeliveryPointFeature";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import errorToast from "./toast/ErrorToast";
import {CART_PATH} from "../routes";

export const AICartModals = observer(({promptModalOpen, setPromptModalOpen, promptText, setPromptText, isSubmittingPrompt, setIsSubmittingPrompt}) => {
    const application = useApplication();
    const navigator = useNavigate();
    const [deliveryModalOpen, setDeliveryModalOpen] = useState(false);
    const [pendingPromptAfterDelivery, setPendingPromptAfterDelivery] = useState(false);
    const [deliverySites, setDeliverySites] = useState([]);
    const [selectDeliveryFeature] = useState(() => new SelectDeliveryPointFeature(application));

    useEffect(() => {
        const loadDeliverySites = async () => {
            try {
                await selectDeliveryFeature.load();
                setDeliverySites([...selectDeliveryFeature.deliverySites]);
            } catch (e) {
                console.warn("No se pudieron cargar los puntos de entrega", e);
            }
        };
        loadDeliverySites();
    }, [selectDeliveryFeature]);

    useEffect(() => {
        if (promptModalOpen && !application.wasOrderChosen() && !pendingPromptAfterDelivery) {
            setPromptModalOpen(false);
            setDeliveryModalOpen(true);
            setPendingPromptAfterDelivery(true);
        }
    }, [promptModalOpen]);

    const handleSetDelivery = async (deliveryPointName, deliveryDate, purchaseOrderNumber) => {
        await selectDeliveryFeature.setDelivery(deliveryPointName, deliveryDate, purchaseOrderNumber);
        setDeliveryModalOpen(false);
        setDeliverySites([...selectDeliveryFeature.deliverySites]);
        if (pendingPromptAfterDelivery) {
            setPendingPromptAfterDelivery(false);
            setPromptModalOpen(true);
        }
    };

    const handleSubmitPrompt = async () => {
        if (!promptText.trim()) {
            return errorToast("Escribe un pedido para el carrito.");
        }

        if (!application.order) {
            setPromptModalOpen(false);
            setPendingPromptAfterDelivery(true);
            setDeliveryModalOpen(true);
            return;
        }

        if (!application.order && application.wasOrderChosen()) {
            errorToast("No se encontró la orden. Intenta nuevamente.");
            return;
        }

        setIsSubmittingPrompt(true);
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                application.setOrder(response.order());
                setPromptModalOpen(false);
                setPromptText('');
                setIsSubmittingPrompt(false);
                navigator(CART_PATH);
            },
            handlesError: (response) => {
                errorToast("No se pudo generar el carrito. Intenta nuevamente.");
                console.error(response);
                setIsSubmittingPrompt(false);
            }
        });

        try {
            await application.apiClient().generateCartFromPrompt(
                application.order.number,
                application.getCustomer().businessName,
                promptText,
                responseHandler
            );
        } finally {
            setIsSubmittingPrompt(false);
        }
    };


    return (
        <>
            <ModalDeliveryPointAndPurchaseOrderNumber
                open={deliveryModalOpen}
                puntosEntrega={deliverySites}
                handleSetDelivery={handleSetDelivery}
                feature={selectDeliveryFeature}
                navigator={navigator}
            />

            {promptModalOpen && (
                <div className="modal fade in" style={{display: 'block', background: 'rgba(0,0,0,0.5)', zIndex: 1050, position: 'fixed', top: 0, left: 0, right: 0, bottom: 0}}>
                    <div className="modal-dialog" style={{marginTop: '50px'}}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={() => {
                                    setPromptModalOpen(false);
                                    setPromptText('');
                                }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <h4 className="modal-title">Armar carrito con IA</h4>
                            </div>
                            <div className="modal-body">
                                <label htmlFor="llmPrompt" style={{fontWeight: 'bold'}}>¿Qué querés pedir?</label>
                                <textarea
                                    id="llmPrompt"
                                    className="form-control"
                                    rows={4}
                                    value={promptText}
                                    onChange={(e) => setPromptText(e.target.value)}
                                    placeholder="Ej: Quiero 2 pizzas romanas y 3 croissants"
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    onClick={() => {
                                        setPromptModalOpen(false);
                                        setPromptText('');
                                    }}
                                    disabled={isSubmittingPrompt}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    style={{backgroundColor: '#c1a17d', borderColor: '#c1a17d'}}
                                    onClick={handleSubmitPrompt}
                                    disabled={isSubmittingPrompt}
                                >
                                    {isSubmittingPrompt ? 'Generando...' : 'Generar carrito'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
});

